import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';

import { FlexColumn } from 'ui-components/components/flex/column';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import { ReturnDetailSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';
import SectionTitle from '../../../tab-section/title';
import { NoteForm } from './note-form';
import { useReturnDataContext } from '../../return-data-provider';
import { useSellerFormattedDateTime } from '../../../../../hooks/use-datetime-formats';

import { messages } from './messages';
import type { Timeline } from '../../enhanced-return-types';
import style from './styles.module.less';

export const ActivityLog = () => {
  const { requestDetails } = useReturnDataContext();

  const timeline = requestDetails?.timeline ?? [];

  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style.content}
      headerContent={<SectionTitle messageDescriptor={messages.sectionHeaderTitle} />}
      sectionContent={
        <FlexColumn className={style.entries} gap={Gap.Space16}>
          <NoteForm />
          {timeline.map((entry, index: number) => (
            <TimelineItem key={index} entry={entry} />
          ))}
        </FlexColumn>
      }
      sectionId={ReturnDetailSectionId.ActivityLog}
    />
  );
};

const TimelineItem = ({ entry }: { entry: Timeline }) => {
  const createdOn = useSellerFormattedDateTime(entry.recordedOn);

  return (
    <FlexColumn>
      <FlexRow className={style.timestamp} gap={Gap.Space8}>
        <FontAwesomeIcon className={style.icon} icon={faClock} />
        <Text textType={TextType.Label} value={createdOn ?? ''} />
      </FlexRow>
      <Text textType={TextType.Paragraph} value={entry.title} />
      {entry.recordedBy && (
        <Text
          className={style.author}
          formattedMessageValues={{ author: entry.recordedBy }}
          textType={TextType.Caption}
          value={messages.timeRecordAuthorText}
        />
      )}
    </FlexColumn>
  );
};
